<template>
  <div class="page">
    <p>
        <el-input size="mini" v-model="data.name" placeholder="亿客账户名称"></el-input>
    </p>
    <p>
        <el-input size="mini" v-model="data.phone" placeholder="手机号" disabled></el-input>
    </p>
    <p>
        <el-input size="mini" v-model="data.company_name" placeholder="公司名称"></el-input>
    </p>
    <p>
        <el-button size="mini" type="primary" @click="saveData">保存修改</el-button>
    </p>
  </div>
</template>

<script>
import md5 from "js-md5";

export default {
  name: "edit",
  data() {
    return {
      data: {
        id: 0,
        name: '',
        phone: '',
        company_name: '',
      },
    };
  },
  activated() {
    this.data.id = this.$route.params.id;
    this.$axios({
        url: '/get_data2',
        method: 'get',
        params: {
            id: this.$route.params.id,
        }
      }).then(res => {
        if (res.data.code == 200) {
          this.data.name = res.data.data.name;
          this.data.phone = res.data.data.phone;
          this.data.company_name = res.data.data.company_name;
        }
      })
  },
  methods: {
    saveData() {
        this.$axios({
            url: '/save_data2',
            method: 'get',
            params: this.data,
        }).then(res => {
            this.$notify.success({
                title: "提示",
                message: "保存成功",
            });
            this.$router.go(-1);
        })
    }
  }
};
</script>

<style lang="less" scoped>
.page {
    padding: 20px;
}
p {
    margin-bottom: 14px;
}
</style>